import { Card, CardContent, CardHeader, Container, Divider, Button, Box } from '@mui/material';
import React from 'react';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Page from 'src/components/Page';
import Pdf from '../../assets/pdf/Apollo-Kullanim-Kilavuzu.pdf';

const styles = {
  root: (theme) => ({
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  })
};

function Overview() {
  return (
    <Page sx={styles.root} title="Apollo Kullanım Kılavuzu">
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="Kullanım Kılavuzu" />
          <Divider />
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <Button
                variant="contained"
                color="secondary"
                size="large"
                startIcon={<PictureAsPdfIcon />}
                component="a"
                href={Pdf}
                target="_blank"
                rel="noopener noreferrer"
              >
                Kullanım Kılavuzunu Görüntüle / İndir
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}

export default Overview;
